import { memo } from "preact/compat"
import { css } from "@emotion/react"
import { Container, Title, Button, ReceiveSvg, CancelSvg, Invalid, MotionDiv } from "./styled"
import Timer from "./Timer"

type ContainerProps = {
    handleOpen: () => void // 处理打开盲盒的回调函数
    handleCancel: () => void // 处理取消操作的回调函数
    onTimeEnd: () => void // 倒计时结束的回调函数
    timer?: number // 倒计时时间（可选）
    claimSuccess?: boolean // 是否领取成功
    amount?: string // 领取金额
    loading?: boolean // 是否加载中
}

const Container_: React.FC<ContainerProps> = (props) => {
    return (
        <Container
            initial={{
                opacity: 0,
            }}
            animate={{
                opacity: 1,
            }}
            transition={{ duration: 0.5, ease: "backIn" }}
        >
            {props.claimSuccess ? (
                <Title
                    css={css`
                        font-size: 30rem !important;
                        margin-bottom: 400rem !important;
                    `}
                >
                    You get
                    <span
                        css={css`
                            font-size: 40rem !important;
                            margin: 0 10rem !important;
                        `}
                    >
                        {props.amount}
                    </span>
                    <span>PHP</span>
                </Title>
            ) : (
                <MotionDiv
                    animate={{
                        opacity: props.loading ? 0 : 1,
                    }}
                    transition={{ duration: 0.5, ease: "easeIn" }}
                >
                    <Title>Open the cash back</Title>

                    <Title
                        css={css`
                            font-size: 30rem !important;
                        `}
                    >
                        GET <span>100%</span> of the prizes
                    </Title>
                    {/* 领取按钮 */}
                    <Button
                        css={css`
                            cursor: ${props.loading ? "not-allowed" : "pointer"};
                            pointer-events: ${props.loading ? "none" : "auto"};
                        `}
                        onClick={(e) => {
                            if (props.loading) return
                            e.stopPropagation() // 阻止事件冒泡
                            props.handleOpen() // 触发打开盲盒逻辑
                        }}
                    >
                        <ReceiveSvg /> {/* 领取图标 */}
                        open
                    </Button>

                    {/* 倒计时提示 */}
                    <Invalid>
                        Mystery Box invalid in
                        <Timer
                            time={props.timer}
                            onTimeEnd={props.onTimeEnd}
                        />
                        {/* 倒计时组件 */}
                    </Invalid>

                    {/* 取消按钮 */}
                    <CancelSvg
                        css={css`
                            cursor: ${props.loading ? "not-allowed" : "pointer"};
                            pointer-events: ${props.loading ? "none" : "auto"};
                        `}
                        onClick={(e) => {
                            if (props.loading) return
                            e.stopPropagation() // 阻止事件冒泡
                            props.handleCancel() // 触发取消逻辑
                        }}
                    />
                </MotionDiv>
            )}
        </Container>
    )
}

export default memo(Container_)
